module.exports = __webpack_public_path__ + "img/calendar.d7189d54.svg";